import {ProductRecommendations} from './productRecommendations'

export {ProductRecommendations}
